import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import Paper from "@mui/material/Paper";

import Checkbox from "@mui/material/Checkbox";

import Table from "@mui/material/Table";

import TableBody from "@mui/material/TableBody";

import TableCell from "@mui/material/TableCell";

import TableContainer from "@mui/material/TableContainer";

import TableHead from "@mui/material/TableHead";

import TableRow from "@mui/material/TableRow";

import SchoolIcon from "@mui/icons-material/School";
import {
    Container,
    Card,
    CardContent,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Snackbar,
    Alert,
    CircularProgress,Box
} from "@mui/material";

const SendHomeWorkSMS = () => {

    //--------------------------------------------------
    // Logged in Staff
    //--------------------------------------------------

    const [staffRegID, setStaffRegID] = useState("");

    //--------------------------------------------------
    // Dropdown Lists
    //--------------------------------------------------

    const [courses, setCourses] = useState([]);
    const [years, setYears] = useState([]);
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);

    //--------------------------------------------------
    // Selected Values
    //--------------------------------------------------

    const [selectedCourse, setSelectedCourse] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
const [selectAll, setSelectAll] = useState(false);
    //--------------------------------------------------
    // Show Section
    //--------------------------------------------------

    const [showSection, setShowSection] = useState(false);

    //--------------------------------------------------
    // Students
    //--------------------------------------------------

    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [tableSearch, setTableSearch] = useState("");
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [subjects,setSubjects]=useState([]);

const [selectedSubject,setSelectedSubject]=useState("");
    //--------------------------------------------------
    // Selected Students
    //--------------------------------------------------

    const [selectedStudents, setSelectedStudents] = useState([]);

    //--------------------------------------------------
    // Table Search
    //--------------------------------------------------

    //const [searchText, setSearchText] = useState("");

    //--------------------------------------------------
    // Loading
    //--------------------------------------------------

    const [loading, setLoading] = useState(false);

    //--------------------------------------------------
    // Snackbar
    //--------------------------------------------------

    const [snack, setSnack] = useState({

        open: false,
        severity: "success",
        message: ""

    });

    //--------------------------------------------------
    // Logged In Staff
    //--------------------------------------------------

    useEffect(() => {

        const regID = sessionStorage.getItem("adminRegId");

        if (regID) {

            setStaffRegID(regID);

        }

    }, []);

    //--------------------------------------------------
    // Load Courses
    //--------------------------------------------------

    const loadCourses = async () => {

        try {

            const res = await axios.get(

                `${BASE_URL}/api/homework/courses`,

                {

                    params: {

                        staffRegID

                    }

                }

            );

            setCourses(res.data);

        }
        catch (err) {

            console.log(err);

        }

    };

    //--------------------------------------------------
    // Load Academic Years
    //--------------------------------------------------

    const loadAcademicYears = async () => {

        if (!selectedCourse) {

            setYears([]);
            return;

        }

        try {

            const res = await axios.get(

                `${BASE_URL}/api/homework/academicYears/${selectedCourse}`

            );

            setYears(res.data);

        }
        catch (err) {

            console.log(err);

        }

    };

    //--------------------------------------------------
    // Load Classes
    //--------------------------------------------------

    const loadClasses = async () => {

        if (!selectedCourse) {

            setClasses([]);
            return;

        }

        try {

            const res = await axios.get(

                `${BASE_URL}/api/homework/classes`,

                {

                    params: {

                        staffRegID,
                        courseId: selectedCourse

                    }

                }

            );

            setClasses(res.data);

        }
        catch (err) {

            console.log(err);

        }

    };

    //--------------------------------------------------
    // Load Sections
    //--------------------------------------------------

    const loadSections = async () => {

        if (!selectedClass) {

            setSections([]);
            setShowSection(false);
            return;

        }

        try {

            const res = await axios.get(

                `${BASE_URL}/api/homework/sections/${selectedClass}`

            );

            if (res.data.length > 0) {

                setSections(res.data);
                setShowSection(true);

            }
            else {

                setSections([]);
                setShowSection(false);
                setSelectedSection("");

            }

        }
        catch (err) {

            console.log(err);

        }

    };

    //--------------------------------------------------
    // Load Students
    //--------------------------------------------------

    const loadStudents = async () => {

        if (!selectedCourse) return;

        if (!selectedYear) return;

        if (!selectedClass) return;

        if (showSection && !selectedSection) return;

        try {

            //setLoading(true);

            setLoadingStudents(true)

            const res = await axios.get(

                `${BASE_URL}/api/homework/students`,

                {

                    params: {

                        staffRegID,

                        courseId: selectedCourse,

                        academicYearId: selectedYear,

                        classId: selectedClass,

                        sectionId:

                            showSection

                                ? selectedSection

                                : null

                    }

                }

            );

            setStudents(res.data);

            setSelectedStudents([]);

        }
        catch (err) {

            console.log(err);

            setStudents([]);

        }
        finally {

            setLoading(false);

        }

    };

    //--------------------------------------------------
    // Load Courses After Login
    //--------------------------------------------------

    useEffect(() => {

        if (staffRegID) {

            loadCourses();

        }

    }, [staffRegID]);

    //--------------------------------------------------
    // Course Changed
    //--------------------------------------------------

    useEffect(() => {

        setSelectedYear("");
        setSelectedClass("");
        setSelectedSection("");

        setStudents([]);

        if (selectedCourse) {

            loadAcademicYears();
            loadClasses();

        }

    }, [selectedCourse]);

    //--------------------------------------------------
    // Class Changed
    //--------------------------------------------------

    useEffect(() => {

        setSelectedSection("");

        if (selectedClass) {

            loadSections();

        }

    }, [selectedClass]);

    //--------------------------------------------------
    // Auto Load Students
    //--------------------------------------------------
  useEffect(() => {

    if (!selectedCourse) {

        setStudents([]);
        setFilteredStudents([]);
        return;

    }

    if (!selectedYear) {

        setStudents([]);
        setFilteredStudents([]);
        return;

    }

    if (!selectedClass) {

        setStudents([]);
        setFilteredStudents([]);
        return;

    }

    if (showSection && !selectedSection) {

        setStudents([]);
        setFilteredStudents([]);
        return;

    }

    loadStudents();

}, [
    selectedCourse,
    selectedYear,
    selectedClass,
    selectedSection
]);
useEffect(() => {

    if (tableSearch.trim() === "") {

        setFilteredStudents(students);

        return;

    }

    const search = tableSearch.toLowerCase();

    const filtered = students.filter(student =>

        student.RollNumber?.toString().toLowerCase().includes(search) ||

        student.StudentName?.toLowerCase().includes(search) ||

        student.ParentName?.toLowerCase().includes(search) ||

        student.MobileNumber?.includes(search) ||

        student.ParentContact?.includes(search)

    );

    setFilteredStudents(filtered);

}, [tableSearch, students]);

//-----------------------------------------------------
    // Subject Changed
    //-----------------------------------------------------
    useEffect(()=>{
        if(
            selectedCourse &&
            selectedYear &&
            selectedClass
        ){
            loadSubjects();
        }
    },[
        selectedCourse,
        selectedYear,
        selectedClass,
        selectedSection
    ]);
    //-----------------------------------------------------
    // Load Subjects
    //-----------------------------------------------------
    const loadSubjects=async()=>{
        try{
            const res=await axios.get(
                `${BASE_URL}/api/homework/subjects`,
                {
                    params:{
                        staffRegID,
                        courseId:selectedCourse,
                        academicYearId:selectedYear,
                        classId:selectedClass,
                        sectionId:
                        showSection
                        ? selectedSection
                        : null
                    }
                }
            );
            setSubjects(res.data);
        }
        catch(err){
            console.log(err);
        }
    };



//--------------------------------------------------
// Select / Unselect All
//--------------------------------------------------

const handleSelectAll = (event) => {

    const checked = event.target.checked;

    setSelectAll(checked);

    const updated = students.map(student => ({
        ...student,
        checked
    }));

    setStudents(updated);
    setFilteredStudents(updated);
};

//--------------------------------------------------
// Select Single Student
//--------------------------------------------------

const handleRowSelect = (studentID) => {

    const updatedStudents = students.map(student =>

        student.StudentID === studentID

            ? {

                ...student,

                checked: !student.checked

            }

            : student

    );

    setStudents(updatedStudents);

    const updatedFiltered = filteredStudents.map(student =>

        student.StudentID === studentID

            ? {

                ...student,

                checked: !student.checked

            }

            : student

    );

    setFilteredStudents(updatedFiltered);

};

//--------------------------------------------------
// Send Selected SMS
//--------------------------------------------------

const handleSendSMS = async () => {

    const selected = students.filter(

        student => student.checked

    );

    if (selected.length === 0) {

        setSnack({

            open: true,

            severity: "error",

            message: "Please select at least one student."

        });

        return;

    }

    try {

        setLoading(true);

        await axios.post(

            `${BASE_URL}/api/homework/sendHomeworkReminderSMS`,

            {

                staffRegID,

                courseId: selectedCourse,

                academicYearId: selectedYear,

                classId: selectedClass,

                sectionId:

                    showSection

                        ? selectedSection

                        : null,

                //students: selected

                students: students.filter(s => s.checked),
                 SubjectID:selectedSubject

            }

        );

        setSnack({

            open: true,

            severity: "success",

            message: `${selected.length} SMS sent successfully.`

        });

        /* const reset = students.map(student => ({

            ...student,

            checked: false

        }));

        setStudents(reset);

        setFilteredStudents(reset); */


        const reset = students.map(student => ({
    ...student,
    checked:false
}));

setStudents(reset);

setFilteredStudents(reset);

setSelectAll(false);

// Clear dropdowns

setSelectedCourse("");

setSelectedYear("");

setSelectedClass("");

setSelectedSection("");

setSelectedSubject("");

// Clear dependent data

setYears([]);

setClasses([]);

setSections([]);

setSubjects([]);

setShowSection(false);

setStudents([]);

setFilteredStudents([]);
    }

    catch (err) {

        setSnack({

            open: true,

            severity: "error",

            message:

                err.response?.data?.message ||

                "Unable to send SMS."

        });

    }

    finally {

        setLoading(false);

    }

};

const handleStudentCheck = (studentID) => {

    const updated = students.map(student =>
        student.StudentID === studentID
            ? {
                  ...student,
                  checked: !student.checked
              }
            : student
    );

    setStudents(updated);
    setFilteredStudents(updated);

    setSelectAll(
        updated.length > 0 &&
        updated.every(student => student.checked)
    );
};

const selectedCount =
    students.filter(s => s.checked).length;
return (
<Container maxWidth="md" sx={{ mt:4, mb:4 }}>
<Card
elevation={6}
sx={{
borderRadius:3
}}
>
<CardContent>
{/*---------------------------------------*/}
{/* HEADER */}
{/*---------------------------------------*/}
<Typography
variant="h4"
align="center"
fontWeight="bold"
color="primary"
gutterBottom
>
<SchoolIcon
sx={{
fontSize:40,
mr:1,
verticalAlign:"middle"
}}
/>
Homework Reminder SMS
</Typography>
<Typography
align="center"
color="text.secondary"
mb={4}
>
Select students who have not submitted today's homework.
</Typography>
<Grid
container
spacing={3}
>
{/*---------------------------------------*/}
{/* COURSE */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Course
</InputLabel>
<Select
value={selectedCourse}
label="Course"
onChange={(e)=>{
setSelectedCourse(e.target.value);
setSelectedYear("");
setSelectedClass("");
setSelectedSection("");
setSelectedSubject("");
}}
>
<MenuItem value="">
Select Course
</MenuItem>
{
courses.map(course=>(
<MenuItem
key={course.CourseID}
value={course.CourseID}
>
{course.CourseName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* ACADEMIC YEAR */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Academic Year
</InputLabel>
<Select
value={selectedYear}
label="Academic Year"
onChange={(e)=>{
setSelectedYear(e.target.value);
}}
>
<MenuItem value="">
Select Academic Year
</MenuItem>
{
years.map(year=>(
<MenuItem
key={year.AcademicYearID}
value={year.AcademicYearID}
>
{year.AcademicYearName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* CLASS */}
{/*---------------------------------------*/}
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Class
</InputLabel>
<Select
value={selectedClass}
label="Class"
onChange={(e)=>{
setSelectedClass(e.target.value);
}}
>
<MenuItem value="">
Select Class
</MenuItem>
{
classes.map(cls=>(
<MenuItem
key={cls.ClassID}
value={cls.ClassID}
>
{cls.ClassName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
{/*---------------------------------------*/}
{/* SECTION */}
{/*---------------------------------------*/}
{
showSection &&
<Grid item xs={12} md={6}>
<FormControl fullWidth>
<InputLabel>
Section
</InputLabel>
<Select
value={selectedSection}
label="Section"
onChange={(e)=>{
setSelectedSection(e.target.value);
}}
>
<MenuItem value="">
Select Section
</MenuItem>
{
sections.map(sec=>(
<MenuItem
key={sec.SectionID}
value={sec.SectionID}
>
{sec.SectionName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>
}
{/*---------------------------------------*/}
{/* SUBJECT */}
{/*---------------------------------------*/}
<Grid item xs={12}>
<FormControl fullWidth>
<InputLabel>
Subject
</InputLabel>
<Select
value={selectedSubject}
label="Subject"
onChange={(e)=>{
setSelectedSubject(e.target.value);
}}
>
<MenuItem value="">
Select Subject
</MenuItem>
{
subjects.map(subject=>(
<MenuItem
key={subject.SubjectID}
value={subject.SubjectID}
>
{subject.SubjectName}
</MenuItem>
))
}
</Select>
</FormControl>
</Grid>

<Grid item xs={12}>

    <TextField
        fullWidth
        size="small"
        label="Search Student"
        value={tableSearch}
        onChange={(e) =>
            setTableSearch(e.target.value)
        }
    />

</Grid>
{
loadingStudents &&

<Box
    sx={{
        textAlign: "center",
        mt: 3
    }}
>

    <CircularProgress />

</Box>

}
<Typography
    sx={{
        mt:2,
        mb:1,
        fontWeight:600
    }}
>

Total Students :
{filteredStudents.length}

</Typography>
<Box
    sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
        mb: 1,
        flexWrap: "wrap",
        gap: 1
    }}
>

    <Typography
        variant="h6"
        sx={{
            fontWeight: 700,
            color: "#1565c0"
        }}
    >
        Student List
    </Typography>

    <Typography
        sx={{
            fontWeight: 600,
            color: "#2e7d32"
        }}
    >
        Selected :
        {
            students.filter(s => s.checked).length
        }
        /
        {students.length}
    </Typography>

</Box>
<TableContainer

    component={Paper}

    sx={{

        mt:2,

        borderRadius:3,

        border:"1px solid #ddd",

        maxHeight:550,

        overflow:"auto"

    }}

>

<Table stickyHeader>

<TableHead>

<TableRow>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:70

}}

>

<Checkbox

checked={selectAll}
/* checked={

students.length>0 &&

students.every(

s=>s.checked

)

} */

indeterminate={

students.some(

s=>s.checked

)

&&

!students.every(

s=>s.checked

)

}

onChange={handleSelectAll}

sx={{

color:"#fff",

'&.Mui-checked':{

color:"#fff"

}

}}

/>

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:90

}}

>

Student ID

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:100

}}

>

Roll No

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:220

}}

>

Student Name

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:220

}}

>

Parent Name

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:150

}}

>

Student Mobile

</TableCell>

<TableCell

sx={{

background:"#1565c0",

color:"#fff",

fontWeight:"bold",

minWidth:150

}}

>

Parent Mobile

</TableCell>

</TableRow>

</TableHead>

<TableBody>

{

filteredStudents.length===0 ?

(

<TableRow>

<TableCell

colSpan={7}

align="center"

sx={{

py:5,

fontWeight:600

}}

>

No Students Found

</TableCell>

</TableRow>

)

:

(

filteredStudents.map(

(student,index)=>(

<TableRow

hover

key={student.StudentID}

sx={{

background:

index%2===0

?

"#fafafa"

:

"#ffffff",

"&:hover":{

background:"#f1f8ff"

}

}}

>

<TableCell>

<Checkbox
checked={student.checked || false}
    onChange={() => handleStudentCheck(student.StudentID)}
/* checked={

student.checked

}

onChange={()=>

handleRowSelect(

student.StudentID

)

} */

/>

</TableCell>

<TableCell>

{student.StudentID}

</TableCell>

<TableCell>

{student.RollNumber}

</TableCell>

<TableCell>

<Typography

fontWeight={600}

>

{student.StudentName}

</Typography>

</TableCell>

<TableCell>

{

student.ParentName ||

"-"

}

</TableCell>

<TableCell>

{

student.MobileNumber ||

"-"

}

</TableCell>

<TableCell>

{/* {

student.ParentContact ||

"-"

} */}

{
student.ParentContact
?

student.ParentContact

:

student.MobileNumber
}

</TableCell>

</TableRow>

)

)

)

}

</TableBody>

</Table>

</TableContainer>

<Box

sx={{

display:"flex",

justifyContent:"flex-end",

mt:3,

mb:2

}}

>

<Button

variant="contained"

size="large"

color="success"

//disabled={loading}
 disabled={selectedCount===0 || loading}

onClick={handleSendSMS}

sx={{

minWidth:220,

fontWeight:"bold",

borderRadius:2,

textTransform:"none",

fontSize:16,

py:1.2

}}

>

{

loading

?

<CircularProgress

size={24}

color="inherit"

/>

:

`Send Selected SMS`

}

</Button>

</Box>


</Grid>

</CardContent>
</Card>
{/*---------------------------------------*/}
{/* SNACKBAR */}
{/*---------------------------------------*/}
<Snackbar

open={snack.open}

autoHideDuration={3000}

onClose={()=>

setSnack({

...snack,

open:false

})

}

anchorOrigin={{

vertical:"top",

horizontal:"right"

}}

>

<Alert

severity={snack.severity}

variant="filled"

onClose={()=>

setSnack({

...snack,

open:false

})

}

>

{snack.message}

</Alert>

</Snackbar>
</Container>
);
}
export default SendHomeWorkSMS;